// extracted by mini-css-extract-plugin
export var actnBtn = "share-actn-btn-module--actn-btn--sD+uI";